import { SearchRounded } from "@mui/icons-material";
import React, { useCallback } from "react";
import styles from "./css/OnevocaSearchInput.module.css";
import { debounce } from "lodash";

interface OnevocaSearchInputProps {
  defaultText?: string;
  hint?: string;
  handleSearch: (searchText: string) => void;
}

export default function OnevocaSearchInput(props: OnevocaSearchInputProps) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedHandleSearch = useCallback(
    debounce((value: string) => {
      props.handleSearch(value);
    }, 300),
    [props.handleSearch]
  );

  function handleInputValueChange(e: React.ChangeEvent<HTMLInputElement>) {
    debouncedHandleSearch(e.target.value);
  }

  return (
    <>
      <div className={styles.container}>
        <SearchRounded className={styles.searchImage} aria-hidden />
        <input
          value={props.defaultText}
          className={styles.searchInput}
          placeholder={props.hint}
          onChange={handleInputValueChange}
        />
      </div>
    </>
  );
}
